<template>
    <p class="m-3" style="text-align:left;">
        <small>Overall Performance</small>
    </p>
     <div style="margin:0;" class="p-fluid p-grid p-formgrid">
      <div style="text-align:left;" class="p-field p-col-12 p-md-4">
            <label>Leads Generated</label>
            <h1 class="m-0">{{ (report.mtdPerformance.leadsGenerated +  dashboard.newLead)?.toLocaleString() }} 
                <small v-if="dashboard.newLead" class="change-indicator">+{{ dashboard.newLead?.toLocaleString() }}</small>
            </h1>
        </div>
        <div style="text-align:left;" class="p-field p-col-12 p-md-4">
            <label>Converted Leads</label>
            <h1 class="m-0">{{ (report.mtdPerformance.convertedLeads + dashboard.convertLead)?.toLocaleString() }}
                <small v-if="dashboard.convertLead" class="change-indicator">+{{ dashboard.convertLead?.toLocaleString() }}</small>
            </h1>
        </div>
        <div style="text-align:left;" class="p-field p-col-12 p-md-4">
            <label>Revenue Generated</label>
            <h1 class="m-0">{{ formatToIndianNotation(report.mtdPerformance.revenueGenerated +  dashboard.revenueGenerated) }}
                <small v-if="dashboard.revenueGenerated" class="change-indicator">+{{ dashboard.revenueGenerated?.toLocaleString() }}</small>
            </h1>
        </div>
     
     </div>
   <div v-for="dash of reports" 
       :key="dash.name">
       <p-panel style="margin-top:5px;" :header="dash.name" collapsed toggleable>
           <DSEDashboard 
               :hide_plus="true"
               :report="dash" />
           <small>Last Checkin {{ (new Date(dash.lastCheckin)).toLocaleString() }}</small>
       </p-panel>
   </div>
 </template>
 
 <script lang="ts">
 import { Options, Vue } from 'vue-class-component';
 import { formatToIndianNotation } from '@/misc/base';
 import DSEDashboard from '@/components/dse_dashboard.vue'
 import { mapState } from 'vuex';
 import { State } from '../store/index';

 @Options({
   props: {
     reports: Array
   },
   components: {
       DSEDashboard
   },
   computed: {
        ...mapState<State>({
            // eslint-disable-next-line
            dashboard: (state : State ) => state.dashboard // Mapping the ws state to a computed property
        })
    },
 })
 export default class RSMDashboard extends Vue {
   reports!: any[]
   report : any = {
       mtdPerformance: {  
           "leadsGenerated": 0,
           "convertedLeads": 0,
           "revenueGenerated": 0,
           "newCustomers": 0
       }
   }
   dashboard! : any

   created(){
       this.calculateTotals(this.reports)
   }
   // Watch for changes in the 'reports' prop and trigger an event
   watch = {
       reports: {
       immediate: true, // Trigger immediately on first load
       handler(newReports: any[]) {
           // Emit an event when the reports prop changes
           // eslint-disable-next-line 
           // @ts-ignore
          this.calculateTotals(newReports)
       },
       deep: true // Watch deeply for changes in nested objects
       }
   };

   calculateTotals(reports: any[]){
       this.report = {
           mtdPerformance: {  
               "leadsGenerated": 0,
               "convertedLeads": 0,
               "revenueGenerated": 0,
               "newCustomers": 0
           }
       }

       for (let d of reports) {
           // Ensure d has mtdPerformance and the respective fields are present
           if (d.mtdPerformance) {
               this.report.mtdPerformance.leadsGenerated += d.mtdPerformance.leadsGenerated || 0;
               this.report.mtdPerformance.convertedLeads += d.mtdPerformance.convertedLeads || 0;
               this.report.mtdPerformance.revenueGenerated += d.mtdPerformance.revenueGenerated || 0;
            
           }
       }
   }

   formatToIndianNotation = formatToIndianNotation

 }
 </script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
 h3 {
   margin: 40px 0 0;
 }
 ul {
   list-style-type: none;
   padding: 0;
 }
 li {
   display: inline-block;
   margin: 0 10px;
 }
 a {
   color: #42b983;
 }
 </style>
 
<!--

    [
  {
    "name": "cheikh",
    "leadsGenerated": 5,
    "revenue": 0,
    "lastCheckin": "2024-01-30T16:39:00.4213608+03:00",
    "Region": "SIMSOL",
    "mtdPerformance": {
      "leadsGenerated": 5,
      "convertedLeads": 0,
      "revenueGenerated": 0
    },
    "dailyPerformance": [
      {
        "leadsToday": 0,
        "conversionRate": 0,
        "date": "2024-08-23T00:00:00Z",
        "newCustomers": 0
      },
    ],
    "targets": {
      "thisMonthTarget": {
        "amount": 110
      },
      "ytdTarget": {
        "amount": 810
      }
    }
  }
]
-->